import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import { Text } from 'components/Text';
import { getLocaleLanguage, getTrans } from 'modules/i18n';
import {
  androidInstallationImages,
  androidInstallationInstructions,
  iosInstallationImages,
  iosInstallationInstructions
} from '../constants';
import { InstallationInstructions } from './InstallationInstructions';
import { TextContainer, TitleContainer } from './styledComponents';

export const InstructionsForDesktopUser = () => {
  const localeLanguage = getLocaleLanguage();

  return (
    <Box data-testid="instructions-for-desktop-container">
      <TextContainer>
        <Text>{getTrans('appInstallPage.instructions.body1')}</Text>
      </TextContainer>
      <TextContainer>
        <Text>{getTrans('appInstallPage.instructions.body2')}</Text>
      </TextContainer>

      <Grid container spacing={5}>
        <Grid container item md={6} direction="column">
          <TitleContainer>
            <Text variant="h4" sx={{ textAlign: 'center' }}>
              iOS
            </Text>
          </TitleContainer>
          <InstallationInstructions
            instructions={iosInstallationInstructions()}
            images={iosInstallationImages[localeLanguage]}
          />
        </Grid>
        <Grid container item md={6} direction="column">
          <TitleContainer>
            <Text variant="h4" sx={{ textAlign: 'center' }}>
              Android
            </Text>
          </TitleContainer>
          <InstallationInstructions
            instructions={androidInstallationInstructions()}
            images={androidInstallationImages[localeLanguage]}
          />
        </Grid>
      </Grid>
    </Box>
  );
};
